import { Card } from '@/design-system/ui/Card';
import { Icon, type IconName } from '@/design-system/ui/Icon';
import { SUPPORT } from '@/core/config/content';
import { useSEO } from '@/core/seo/useSEO';
import { PageHeader } from '../components/PageHeader';

const ITEMS: { icon: IconName; label: string; value: string; href?: string; ltr?: boolean }[] = [
  { icon: 'phone', label: 'تماس تلفنی', value: SUPPORT.phoneDisplay, href: `tel:${SUPPORT.phone}` },
  { icon: 'mail', label: 'ایمیل پشتیبانی', value: SUPPORT.email, href: `mailto:${SUPPORT.email}`, ltr: true },
  { icon: 'pin', label: 'آدرس دفتر مرکزی', value: SUPPORT.city },
];

export default function ContactPage() {
  useSEO({
    title: 'تماس با پشتیبانی',
    description: 'راه‌های ارتباط با تیم پشتیبانی بلینو؛ تلفن پشتیبانی ۲۴ ساعته ۰۹۰۰۵۵۲۰۱۵۳، پیام‌رسان‌های بله، ایتا و تلگرام و ایمیل سازمانی.',
    canonical: '/contact',
    keywords: 'تماس با بلینو, تلفن پشتیبانی بلینو, شماره پشتیبانی تاکسی بین شهری, پشتیبانی بار بلینو',
  });

  return (
    <div className="mx-auto max-w-4xl px-4 py-8">
      <PageHeader icon="users" title="تماس با پشتیبانی" subtitle="از راه‌های زیر با ما در ارتباط باشید" />
      <ul className="grid gap-4 sm:grid-cols-3">
        {ITEMS.map((i) => (
          <li key={i.label}>
            <Card className="h-full p-5">
              <span className="mb-3 grid size-10 place-items-center rounded-md bg-primary-light text-navy"><Icon name={i.icon} size={20} /></span>
              <p className="text-xs text-ink-2">{i.label}</p>
              {i.href ? (
                <a href={i.href} dir={i.ltr ? 'ltr' : undefined} className="block break-all font-bold hover:underline">{i.value}</a>
              ) : (
                <p className="font-bold">{i.value}</p>
              )}
            </Card>
          </li>
        ))}
      </ul>
      <p className="mt-6 text-sm text-ink-2">
        برای شکایت از تأخیر یا آسیب مرسوله از صفحهٔ «ثبت شکایت» استفاده کنید.
      </p>
    </div>
  );
}
